import React from "react";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";

export default function JournalTable({
                                       data,
                                       pagination,
                                       onPageChange,
                                       onSort,
                                       // onDelete,
                                       onRowClick,
                                       selectedIds,
                                       setSelectedIds,
                                       onDeleteRequest,
                                       setIsDownloadSelected,
                                       isReflectionLibrary = false,
                                     }) {
  const navigate = useNavigate();
  const handlePaginationChange = (page) => {
    if (page > 0 && page <= pagination.last_page) {
      onPageChange(page);
    }
  };
  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setSelectedIds((prev) => [...prev, id]);
    } else {
      setSelectedIds((prev) => prev.filter((itemId) => itemId !== id));
    }
  };

  const isChecked = (id) => selectedIds.includes(id);



  // Builds a compact pagination model like: 1 … 8 9 10 11 12 … 28 (prevents long horizontal lists)
  const getPageItems = (current, last, delta = 2) => {
    const range = [];
    const rangeWithDots = [];
    let prev;

    for (let i = 1; i <= last; i++) {
      if (i === 1 || i === last || (i >= current - delta && i <= current + delta)) {
        range.push(i);
      }
    }

    for (const i of range) {
      if (prev) {
        if (i - prev === 2) {
          rangeWithDots.push(prev + 1);
        } else if (i - prev > 2) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      prev = i;
    }

    return rangeWithDots;
  };

  return (
      <div className="container mt-5 p-0">
        <div className="table-responsive">
          <table className="table custom-table">
            <thead>
            <tr className="text-body-b2" style={{ fontWeight: 600 }}>
              {/* <th>
                <input type="checkbox" />
              </th> */}
              <th>
                <input
                    type="checkbox"
                    checked={data.length > 0 && selectedIds.length === data.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        const allIds = data.map((item) => item.id);
                        setSelectedIds(allIds);
                      } else {
                        setSelectedIds([]);
                      }
                    }}
                />
              </th>

              <th
                  onClick={() => {
                    if (isReflectionLibrary) {
                      onSort("emotion_name");
                    } else {
                      onSort("type");
                    }
                  }}
                  style={{ cursor: "pointer" }}
              >
                Type
                <img
                    style={{ marginLeft: "8px" }}
                    src="/icons/arrow-down-up.svg"
                    alt="Sort"
                />
                {pagination.sort_by ===
                    (isReflectionLibrary ? "emotion_name" : "type") && (
                        <span style={{ marginLeft: "4px" }}>
                    {pagination.sort_order === "asc" ? "↑" : "↓"}
                  </span>
                    )}
              </th>
              <th
                  onClick={() => {
                    if (isReflectionLibrary) {
                      onSort("main_question");
                    } else {
                      onSort("emotion_name");
                    }
                  }}
                  style={{ cursor: "pointer" }}
              >
                Title
                <img
                    style={{ marginLeft: "8px" }}
                    src="/icons/arrow-down-up.svg"
                    alt="Sort"
                />
                {/* {pagination.sort_by === "main_question" && (
                  <span style={{ marginLeft: "4px" }}>
                    {pagination.sort_order === "asc" ? "↑" : "↓"}
                  </span>
                )} */}
              </th>
              <th
                  onClick={() => onSort("completed_at")}
                  style={{ cursor: "pointer" }}
              >
                Date
                <img
                    style={{ marginLeft: "8px" }}
                    src="/icons/arrow-down-up.svg"
                    alt="Sort"
                />
                {pagination.sort_by === "completed_at" && (
                    <span style={{ marginLeft: "4px" }}>
                    {pagination.sort_order === "asc" ? "↑" : "↓"}
                  </span>
                )}
              </th>
              <th className="text-center-journal">Actions</th>
            </tr>
            </thead>

            <tbody className="text-body-b2">
            {data.length > 0 ? (
                data.map((item, index) => (
                    <tr
                        key={index}
                        onClick={(e) => {
                          if (!e.target.closest('input[type="checkbox"]')) {
                            if (item.is_completed) {
                              onRowClick(item);
                            } else {
                              if (isReflectionLibrary) {
                                navigate(`/reflection-journal/${item.type}`, {
                                  state: { id: item.id },
                                });
                              } else {
                                navigate(`/journal/${item.name}`, {
                                  state: { id: item.id },
                                });
                              }
                            }
                          }
                        }}
                        style={{
                          cursor: "pointer",
                        }}
                    >
                      <td onClick={(e) => e.stopPropagation()}>
                        <input
                            type="checkbox"
                            checked={isChecked(item.id)}
                            onChange={(e) => handleCheckboxChange(e, item.id)}
                        />
                      </td>

                      <td
                          style={{
                            color: item.is_completed
                                ? "var(--Primary-500, #008cff) !important"
                                : "",
                          }}
                      >
                        {isReflectionLibrary
                            ? item.type.charAt(0).toUpperCase() + item.type.slice(1)
                            : item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                      </td>
                      <td
                          style={{
                            color: item.is_completed
                                ? "var(--Primary-500, #008cff) !important"
                                : "",
                          }}
                      >

                        {item && item.title_question_answer ? (
                            <span
                                className="answer-span-no-margin"
                                dangerouslySetInnerHTML={{
                                  __html: item.title_question_answer,
                                }}
                            ></span>
                        ) : (
                            parse(item.firstMainQuestionAnswer)
                        )}
                      </td>
                      <td
                          style={{
                            color: item.is_completed
                                ? "var(--Primary-500, #008cff) !important"
                                : "",
                          }}
                      >
                        {item.date}
                      </td>
                      <td
                          className="text-center actions"
                          style={{
                            justifyContent: "center",
                            display: "flex",
                            gap: "10px",
                          }}
                      >
                        <img
                            src="/icons/outline-document.svg"
                            alt="Document"
                            onClick={() => {
                              setIsDownloadSelected(true);
                            }}
                            style={{ cursor: "pointer" }}
                        />
                        <img
                            src="/icons/journal-delete-icon.svg"
                            alt="Delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              onDeleteRequest(item.id);
                            }}
                            style={{ cursor: "pointer" }}
                        />{" "}
                        <img
                            src="/icons/journal-share-icon.svg"
                            alt="Share"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              // Prevent the row click handler from firing
                              e.stopPropagation();

                              // If the journal is not completed, navigate to the reflection/journal
                              // flow (same behavior as download/navigation for incomplete journals).
                              if (!item.is_completed) {
                                if (isReflectionLibrary) {
                                  navigate(`/reflection-journal/${item.type}`, {
                                    state: { id: item.id },
                                  });
                                } else {
                                  navigate(`/journal/${item.name}`, {
                                    state: { id: item.id },
                                  });
                                }
                                return;
                              }

                              // Otherwise force open the journal summary modal via parent handler
                              onRowClick(item, true);
                            }}
                        />
                      </td>
                    </tr>
                ))
            ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No data available
                  </td>
                </tr>
            )}
            </tbody>
            <tfoot>
            <tr>
              <td colSpan="5">
                <div className="pagination-container">
                  <div>
                    <span
                        className="body-2-regular"
                        style={{ marginRight: "20px", color: "#e6ecf1" }}
                    >
                      Showing
                    </span>
                    <select
                        className="text-body-b2"
                        value={pagination.per_page}
                        onChange={(e) => onPageChange(1, e.target.value)}
                        style={{
                          background:
                              'url("/icons/table-arrow-down.svg") no-repeat',
                          backgroundSize: "20px 20px",
                          backgroundPosition: "right 12px center",
                          appearance: "none",
                          borderRadius: "10px",
                          border: "1px solid #1b2c3a",
                          padding: "8px 16px",
                          height: "46px",
                          width: "76px",
                          color: "#d0d8df",
                          backgroundColor: "#121e29",
                        }}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                    </select>
                  </div>

                  <span className="body-2-regular" style={{ color: "#e6ecf1" }}>
                    Showing {pagination.current_page} to{" "}
                    {pagination.current_page * pagination.per_page} out of{" "}
                    {pagination.total} records
                  </span>

                  <nav>
                    <ul className="pagination" style={{ gap: "5px" }}>
                      <li className="page-item">
                        <button
                            className="page-link"
                            onClick={() =>
                                handlePaginationChange(pagination.current_page - 1)
                            }
                            disabled={pagination.current_page === 1}
                        >
                          <img src="/icons/pagination-left-icon.svg" alt="" />
                        </button>
                      </li>

                      {getPageItems(
                          pagination.current_page,
                          pagination.last_page,
                          2
                      ).map((p, idx) => {
                        if (p === "...") {
                          return (
                              <li key={`dots-${idx}`} className="page-item disabled">
                                <span className="page-link">…</span>
                              </li>
                          );
                        }

                        return (
                            <li
                                key={p}
                                className={`page-item ${
                                    pagination.current_page === p ? "active" : ""
                                }`}
                            >
                              <button
                                  className="page-link"
                                  onClick={() => handlePaginationChange(p)}
                              >
                                {p}
                              </button>
                            </li>
                        );
                      })}

                      <li className="page-item">
                        <button
                            className="page-link"
                            onClick={() =>
                                handlePaginationChange(pagination.current_page + 1)
                            }
                            disabled={
                                pagination.current_page === pagination.last_page
                            }
                        >
                          <img src="/icons/pagination-right-icon.svg" alt="" />
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
  );
}
